/** Every Story moderation query sits under this prefix; any Story change invalidates all of it. */
export const STORIES_KEY = ['admin-stories']

export const storyReviewsKey = (storyId: string) => [...STORIES_KEY, 'reviews', storyId]
